
import * as _ from 'lodash';

export default angular.module("mars.vet.dnareports.controllers.allclear",[]).controller('AllClearController',
        function($rootScope, $scope, $window, EntryService, EntryIDService, ImageService, NavigationService, TranslationService, DisorderDataService,
                reportdata) {

        var reportType = 'online';
        $scope.onloadFun = function() {
            reportType = 'pdf';
        }

        EntryService.getEntry(EntryIDService.getEntryID('All Clear')).then(function(response) {
            var fields = response.fields;
            if (reportType != 'pdf') {
                $rootScope.pageTitle = fields.title;
            }
            $scope.title = fields.title;
            $scope.description = fields.description;
            $scope.subtitle = fields.subtitle;
        });

        let disorders = DisorderDataService.getDisorders();
        let disorderKeySet = Object.keys(disorders);
        let allClear = DisorderDataService.getAllClearData();
        let disorderMap = {};
        let diseaseCategory = [];


        _.each(disorderKeySet, (key) => {
          let disorder = disorders[key];
          if(!disorderMap[disorder.diseaseCategory]){
            disorderMap[disorder.diseaseCategory] = new Array();
            diseaseCategory.push(disorder.diseaseCategory);
          }
        });

        _.each(allClear, (clearedDisorder) => {
                let disorder = disorders[clearedDisorder.locusName];
                if(!disorder){ return;}
                disorderMap[disorder.diseaseCategory].push({
                  locusname: disorder.locusname
                  ,diseaseLongName: disorder.diseaseLongName
                  ,entryId: disorder.entryId
                  ,diseaseCategory: disorder.diseaseCategory
                });
        });
        
        _.each(diseaseCategory, (category) => {
            disorderMap[category].sort(function(a, b) { return a.diseaseLongName < b.diseaseLongName ? -1 : a.diseaseLongName > b.diseaseLongName ? 1 : 0;});
        });

        $scope.disorderMap = disorderMap;

        ImageService.getImageUrl('JwWqM1wbQIEAMiSeoakKk').then(function(response) {
            $scope.mainStatusIcon = response.data.fields.file.url;
        });
        ImageService.getImageUrl('28BD224gKUUocC2WC2MuGE').then(function(response) {
            $scope.subStatusIcon = response.data.fields.file.url;
        });
        NavigationService.setNavigationUrls();
        $scope.translation = TranslationService.getTranslation;
        $scope.locale = reportdata.locale;
        $window.ga('send', 'pageview', {
            'page': $scope.title
        });
}).name;



// WEBPACK FOOTER //
// ./client/apps/dnareport/controllers/allclear.controller.js